import { Component, OnInit, ViewChild } from '@angular/core';
import { ProfitDataComponent } from '../profit-data/profit-data.component';
import { Router } from '@angular/router';
import { CpmService } from 'app/service/cpm.service';
import { environment } from '../../../environments/environment';
import { ExportPPTService } from 'app/service/export-ppt.service';
import { ExportExcelService } from '../../service/export-excel.service';
@Component({
  selector: 'app-profit',
  templateUrl: './profit.component.html',
  styleUrls: ['./profit.component.scss']
})
export class ProfitComponent implements OnInit {
  loadGraphFirstTime = true;

  @ViewChild(ProfitDataComponent) profitDataComponent: ProfitDataComponent;
  constructor(
    private excelService: ExportExcelService,
    private pptService: ExportPPTService,
    private cpmService: CpmService
  ) { }

  initialChart() {
    if (this.loadGraphFirstTime) {
      this.profitDataComponent.makeChart();
    }
    this.loadGraphFirstTime = false;
  }
  ngOnInit() { }

  exportFunctionsProfit() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();
    arrayOfFunctions.set(
      'email',
      this.exportEmailProfit(
        this.cpmService,
      )
    );

    arrayOfFunctions.set(
      'print',
      this.exportPrintProfit()
    );

    arrayOfFunctions.set(
      'pdf',
      this.exportPdfProfit()
    );

    arrayOfFunctions.set(
      'excel',
      this.exportExcelProfit(
        this.excelService,
        this.profitDataComponent.listHeader,
        this.profitDataComponent.listProfitData,
      )
    );

    arrayOfFunctions.set(
      'ppt',
      this.exportPptProfit(
        this.pptService,
        this.profitDataComponent
      )
    )
    return arrayOfFunctions;
  }

  exportEmailProfit(service) {
    return function mailProfit() {
      service.saveProfitDataPdfFile().then(filename => {
        const subject = 'Profit-Data';
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        );
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`;
      });
    };
  }

  exportPrintProfit = function () {
    return function ProfitPrint() {
      const popupWin = window.open(
        `/#/profitdata/`,
        '_blank',
        'width=850px,height=1024px'
      );
    };
  };

  exportPdfProfit = function () {
    const service = this.cpmService;
    return function ProfitPdf() {
      service.downloadFile(
        `${environment.cpmBaseUrl}/pdf/profitdata`
      );
    };
  };

  exportExcelProfit(service, listHeader, listProfitData) {
    return function excelProfit() {
      const ws_data = [];
      ws_data.push([...listHeader])
      listProfitData.map(obj => {
        const list = [
          obj.market,
          obj.pts,
          obj.pe,
          obj.indexChange,
          Number(obj.year1).toFixed(0),
          Number(obj.year2).toFixed(0),
          Number(obj.year3).toFixed(0),
          Number(obj.year4).toFixed(0),
          Number(obj.ytd).toFixed(0),
          Number(obj.total).toFixed(0)
        ]
        ws_data.push([...list])
      });
      service.exportExcelData(ws_data, 'Profit-Data')
    }
  };

  exportPptProfit(service, profitDataComponent) {
    return function pptProfit() {
      // tslint:disable-next-line:max-line-length
      service.pptProfit(profitDataComponent.listYear, profitDataComponent.dataProvider, profitDataComponent.listProfitData, profitDataComponent.listHeader)
    };
  };

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/profit/profit.component.ts